import { render, staticRenderFns } from "./StudentInformationModal.vue?vue&type=template&id=0d3dd3b8&"
import script from "./StudentInformationModal.vue?vue&type=script&lang=js&"
export * from "./StudentInformationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports